export const ENDPOINT_STATUS_CHECKING = 'checking';
export const ENDPOINT_STATUS_OFFLINE = 'offline';
export const ENDPOINT_STATUS_ONLINE = 'online';
